import { render, staticRenderFns } from "./BattlenetAccount.vue?vue&type=template&id=9cfaff1e&scoped=true"
import script from "./BattlenetAccount.vue?vue&type=script&lang=js"
export * from "./BattlenetAccount.vue?vue&type=script&lang=js"
import style0 from "./BattlenetAccount.vue?vue&type=style&index=0&id=9cfaff1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfaff1e",
  null
  
)

export default component.exports